<template>
  <div class="team-member-page-container container">
        <section class="team-member">
            <div class="row-custom">
                <div class="individual-col">
                        <img :src="require(`../assets/images/${activeMember.image}`)">
                        <h3>{{ activeMember.name }}</h3>
                        <span>{{ activeMember.function }}</span>
                </div>
                <div class="individual-col-text">
                    <div class="about-yourself" v-html="activeMember.text">
                    </div>
                 <router-link @click="scrollToTop()" :to="'/het-team'" class="hero-btn red-btn">Terug</router-link> 

                </div>
            </div>
        </section>
      </div>
</template>

<script>
export default {
   name: "TeamMember",
   computed: {
    memberId(){
            return this.$route.params.memberid
        },
        activeMember(){
            return this.$store.state.members.find(member => member.id == this.memberId)
        }
    },
    methods: {
    scrollToTop() {
          window.scrollTo(0,0);
      }
    }
}
</script>

<style>
.team-member-page-container {
  margin-top: 145px;
  margin-bottom: 75px;
  /* background-color: #F2F2F2; */
}
.team-member {
    text-align: center;
}
.individual-col {
    flex-basis: 31%;
    background: #FFF3F3;
    border-radius: 10px;
    /* margin-top: 5px; */
    box-sizing: border-box;
    transition: 0.5s;
}
.individual-col h3{
    color: #000000;
    padding-top: 25px;
    padding-bottom: 0px;
}
.individual-col span{
    color: #606060;
    font-size: 14px;
}
.individual-col img {
    width: 100%;
    max-width: 375px;
}
.team-member .row-custom .individual-col  {
    display: block;
    padding: 43px 40px 35px;
    text-decoration: none;
}
.individual-col-text {
    /* background-color: pink; */
    flex-basis: 61%;
}
.individual-col-text .about-yourself {
    text-align: left;
    margin-bottom: 10px;
    white-space: pre-wrap;
    font-size: 16px;
}
.about-yourself .new-line {
    display: block;
    padding-top: 13px;
}

.hero-btn {
    display: inline-block;
    text-decoration: none !important;
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
    padding: 12px 34px;
    font-size: 16px;
    background: transparent;
    position: relative;
    cursor: pointer;
}
.hero-btn:hover {
    border: 1px solid var(--blue);
    background: var(--blue);
    transition: 1s;
}
.red-btn {
    border: 1px solid var(--blue);
    background: transparent;
    color: var(--blue);
    margin-top: 30px;
}
.red-btn:hover {
    color: #FFF;
}
@media(max-width: 978px) {
    .team-member-page-container {
        margin-top: 60px;
        margin-bottom: 0px;
        /* background-color: #F2F2F2; */
    }
    .row-custom {
        flex-direction: column;
    }
    .individual-col, .individual-col-text {
        max-width: 300px;
        margin: auto;
    }
    .team-member {
        padding: 50px 0 50px;        /* t lr b */
    }
    .individual-col {
        margin: auto;
    }
    .individual-col-text {
        margin-top: 40px;
    }
}

</style>